<!--
 * @Author: WLL
 * @Date: 2020-03-28 10:48:00
 * @LastEditors: WLL
 * @LastEditTime: 2020-03-28 16:12:34
 * @Description: file content
 -->
<template>
  <div>
    <SjButton @click="handleClick" style="margin:10px;"
      >点击弹出dialog</SjButton
    >
    <SjDialog
      title="提示"
      :visible="visible"
      @close="handleClose"
      @closed="handleClosed"
      @shown="handleShown"
      @confirm="handleConfirm"
      :closeOnEsc="false"
      :draggable="true"
      dragSelector=".dragBox"
      :showWrapper="false"
    >
      <span>自定义内容</span>
      <span class="dragBox" style="margin-left: 30px;">拖拽区域</span>
      <sj-input style="margin-left: 10px;" border v-model="text"></sj-input>
      <SjButton @click="handleClick1" style="margin:10px;"
        >点击弹出多层dialog</SjButton
      >
    </SjDialog>

    <SjDialog
      title="提示"
      :visible="visible1"
      @close="handleClose1"
      width="500px"
    >
      <span>更多自定义内容</span>
      <sj-input style="margin-left: 10px;" border v-model="text"></sj-input>
    </SjDialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      visible1: false,
      options: [
        {
          label: "test1",
          value: 1
        },
        {
          label: "test2",
          value: 2
        },
        {
          label: "test3",
          value: 3
        },
        {
          label: "test4",
          value: 4
        }
      ],

      text: null
    };
  },
  methods: {
    handleClick() {
      this.visible = true;
    },
    handleClick1() {
      this.visible1 = true;
    },
    handleClose() {
      this.visible = false;
    },

    handleClose1() {
      this.visible1 = false;
    },

    handleClosed() {
      console.log("closed");
    },
    handleShown() {
      console.log("shown");
    },
    handleConfirm() {
      alert("确认");
    }
  }
};
</script>

<style scoped lang="less"></style>
